export default {
  user: {},
  merchantData: {
    current_advance:{
      amount: '',
      balance: '',
      expected_repayment_date: '',
      percentage_repaid: '',
      payments_remaining: 0
    },
  },
  statements: {
    data: null,
    errors: [],
    loading: false,
    current: null
  },
  accountRepData: {
    account_representative: {
      title: "",
      imgSrc: "https://us.123rf.com/450wm/tuktukdesign/tuktukdesign1611/tuktukdesign161100037/68324166-customer-service-support-help-desk-call-center-vector-icon.jpg?ver=6",
      name: "Contact Us",
      description: "We are here to help! \nPlease reach out with any questions or concerns.",
      email: "customersupport@forwardfinancing.com",
      phone: "888-244-9099"
    }
  }
};
